import { NgClass } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { Component, ViewEncapsulation, input, output } from "@angular/core";

@Component({
  selector: "app-button",
  standalone: true,
  imports: [NgClass, MatButtonModule, TranslateModule],
  templateUrl: "./button.component.html",
  styleUrl: "./button.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent {
  readonly type = input<"submit" | "button">("button");
  readonly color = input<"primary" | "accent" | "warn" | null>(null);
  readonly btnLabel = input<string>();
  readonly btnClass = input<string>();
  readonly disabled = input(false);
  readonly iconPosition = input<"right" | "left">("right");

  readonly onClick = output();
  readonly onHover = output();
}
